import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, MapPin, Trophy, ExternalLink } from 'lucide-react';

const PastAwards = () => {
  const pastAwards = [
    {
      id: 1,
      name: "INTERNATIONAL ICONIC AWARD",
      date: "August 25th, 2024",
      venue: "Cordelia Cruise",
      organizer: "International Education Council",
      country: "International Waters",
      photos: Array(8).fill(0).map((_, i) => `/awards/award1/img${i + 1}.jpg`),
      about: "The International Iconic Award recognizes outstanding contributions to global education and research excellence. This prestigious award celebrates individuals and institutions that have made significant impacts in advancing educational methodologies and research innovations worldwide."
    },
    {
      id: 2,
      name: "IND – SL Pride of Education Awards",
      date: "January 23rd, 2024",
      venue: "Eastern University, Sri Lanka",
      organizer: "Indo-Sri Lankan Education Board",
      country: "Sri Lanka",
      photos: Array(8).fill(0).map((_, i) => `/awards/award2/img${i + 1}.jpg`),
      about: "The IND-SL Pride of Education Awards celebrate the collaborative efforts between India and Sri Lanka in promoting educational excellence. This award recognizes outstanding achievements in cross-cultural educational initiatives and research collaborations."
    },
    {
      id: 3,
      name: "INDO – THAI International Excellence Awards",
      date: "February 27th, 2024",
      venue: "Bangkok, Thailand",
      organizer: "Indo-Thai Education Alliance",
      country: "Thailand",
      photos: Array(8).fill(0).map((_, i) => `/awards/award3/img${i + 1}.jpg`),
      about: "The Indo-Thai International Excellence Awards honor exceptional contributions to educational development and research innovation between India and Thailand. This award promotes international cooperation in academic excellence and educational advancement."
    },
    {
      id: 4,
      name: "Education Excellence Award 2021",
      date: "March 08th, 2021",
      venue: "TOWN HALL, Bangalore",
      organizer: "Education Excellence Foundation",
      country: "India",
      photos: Array(8).fill(0).map((_, i) => `/awards/award4/img${i + 1}.jpg`),
      about: "The Education Excellence Award 2021 recognizes outstanding achievements in educational innovation and research excellence. This award celebrates individuals and institutions that have demonstrated exceptional commitment to advancing education and research methodologies."
    }
  ];

  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      {/* Header */}
      <div style={{ padding: '40px 24px 0' }}>
        <div className="container-custom">
          <Link to="/awards" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: '#ffd700', textDecoration: 'none', marginBottom: '30px', fontWeight: '600' }}>
            <ArrowLeft size={20} />
            <span>Back to Awards</span>
          </Link>
          
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <div style={{
              display: 'inline-block',
              background: 'linear-gradient(135deg, #ffd700 0%, #ffb347 100%)',
              color: 'white',
              padding: '12px 30px',
              borderRadius: '25px',
              fontSize: '1rem',
              fontWeight: 'bold',
              marginBottom: '20px'
            }}>
              🏆 AWARDS ARCHIVE
            </div>
            <h1 style={{ color: '#2d3748', fontSize: '3rem', fontWeight: 700, marginBottom: '20px' }}>Past Awards</h1>
            <p style={{ color: '#718096', fontSize: '1.2rem', maxWidth: '600px', margin: '0 auto' }}>
              Celebrating excellence in education and research from our prestigious award ceremonies
            </p>
          </div>
        </div>
      </div>

      {/* Past Awards List */}
      <div className="container-custom" style={{ padding: '0 24px 80px' }}>
        <div style={{ display: 'grid', gap: '50px' }}>
          {pastAwards.map((award, index) => (
            <div key={award.id} style={{ 
              background: index % 2 === 0 
                ? 'linear-gradient(135deg, #ffd700 0%, #ffb347 100%)' 
                : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
              padding: '3px', 
              borderRadius: '20px', 
              boxShadow: '0 8px 32px rgba(255, 215, 0, 0.2)' 
            }}>
              <div style={{ 
                backgroundColor: 'white', 
                padding: '50px', 
                borderRadius: '17px'
              }}>
                {/* Award Header */}
                <div style={{ marginBottom: '40px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px' }}>
                    <Trophy size={32} color="#ffd700" />
                    <h2 style={{ color: '#2d3748', fontSize: '2.2rem', fontWeight: 700, margin: 0 }}>
                      {award.name}
                    </h2>
                  </div>
                  
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '30px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <Calendar size={20} color="#ffd700" />
                      <span style={{ color: '#4a5568', fontWeight: 600 }}>{award.date}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <MapPin size={20} color="#ffd700" />
                      <span style={{ color: '#4a5568', fontWeight: 600 }}>{award.venue}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span style={{ fontSize: '20px' }}>🏢</span>
                      <span style={{ color: '#4a5568', fontWeight: 600 }}>Organizer: {award.organizer}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span style={{ fontSize: '20px' }}>🌍</span>
                      <span style={{ color: '#4a5568', fontWeight: 600 }}>Country: {award.country}</span>
                    </div>
                  </div>
                </div>

                {/* About Award */}
                <div style={{ marginBottom: '40px' }}>
                  <h3 style={{ color: '#2d3748', fontSize: '1.5rem', fontWeight: 700, marginBottom: '20px' }}>About Award</h3>
                  <p style={{ color: '#4a5568', fontSize: '1.1rem', lineHeight: '1.7' }}>{award.about}</p>
                </div>

                {/* Award Gallery */}
                <div>
                  <h3 style={{ color: '#2d3748', fontSize: '1.5rem', fontWeight: 700, marginBottom: '30px' }}>Award Gallery</h3>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' }}>
                    {award.photos.map((photo, photoIndex) => (
                      <div key={photoIndex} style={{
                        height: '200px',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        backgroundColor: '#e2e8f0',
                        cursor: 'pointer',
                        transition: 'transform 0.2s ease'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                      onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                        <img 
                          src={photo} 
                          alt={`${award.name} Photo ${photoIndex + 1}`}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                          }}
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.parentElement.innerHTML = `<div style="display: flex; align-items: center; justify-content: center; height: 100%; color: #718096; font-size: 0.9rem; font-weight: 600;">🏆 Award Photo ${photoIndex + 1}</div>`;
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>

                </div>
              </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PastAwards;